// extracted by mini-css-extract-plugin
export default {"devider":"NewsDetail_devider__65Mlu","detailHeading":"NewsDetail_detailHeading__1DFLe"};